import { FC } from 'react';

import { Notification } from '@purpur/library';

import { ESHOP_TEST_ID } from '@telialt/core-eshop/src/test/test-ids';

import { useLeasingRestriction } from './useLeasingRestriction';

export const RestrictionMessageNotification: FC = () => {
    const restriction = useLeasingRestriction();

    if (restriction) {
        return (
            <Notification
                data-test={ESHOP_TEST_ID.RESTRICTION_INFO}
                heading={restriction.title}
                status={restriction.severity}
                headingTag="h4"
            >
                <div>{restriction.message}</div>
            </Notification>
        );
    }

    return null;
};
